import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Button
          onClick={() => navigate("/")}
          variant="ghost"
          className="mb-8"
        >
          ← Back to Home
        </Button>

        <h1 className="text-4xl font-bold mb-4 font-serif">Terms & Conditions</h1>
        <p className="text-sm text-gray-600 mb-8">Last Updated: October 21, 2025</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">1. Acceptance of Terms</h2>
            <p>
              By subscribing to the 21-Day AI Challenge, you agree to be bound by these Terms & Conditions. If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">2. Service Description</h2>
            <p>
              The 21-Day AI Challenge is a free educational email campaign designed to help you learn about artificial intelligence tools and strategies over 21 days. We will send one email per work day to your registered email address.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">3. User Obligations</h2>
            <p>By using our service, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and current email information</li>
              <li>Use the service for personal, educational purposes only</li>
              <li>Not share or redistribute our content without permission</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
              <li>Not attempt to interfere with the proper functioning of the service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">4. Intellectual Property</h2>
            <p>
              All content provided in the 21-Day AI Challenge emails, including but not limited to text, graphics, logos, and educational materials, is owned by Avodah or its licensors and is protected by copyright and intellectual property laws.
            </p>
            <p className="mt-2">
              You may not reproduce, distribute, modify, or create derivative works from our content without explicit written permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">5. Disclaimer of Warranties</h2>
            <p>
              The 21-Day AI Challenge is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>The service will be uninterrupted or error-free</li>
              <li>The content will always be accurate or up-to-date</li>
              <li>You will achieve any specific results from the campaign</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">6. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Avodah shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service, even if we have been advised of the possibility of such damages.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">7. Subscription and Cancellation</h2>
            <p>
              You may unsubscribe from the 21-Day AI Challenge at any time by clicking the unsubscribe link in any email. Upon unsubscribing, you will no longer receive emails from the campaign.
            </p>
            <p className="mt-2">
              We reserve the right to suspend or terminate your subscription at our discretion if we believe you have violated these terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">8. Changes to Service</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue the 21-Day AI Challenge at any time without prior notice. We are not liable to you or any third party for any modification, suspension, or discontinuance of the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">9. Educational Purpose Only</h2>
            <p>
              The content provided in the 21-Day AI Challenge is for educational and informational purposes only. It should not be considered professional advice. You should consult with appropriate professionals for specific advice tailored to your situation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">10. Third-Party Links</h2>
            <p>
              Our emails may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of any third-party sites.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">11. Governing Law</h2>
            <p>
              These Terms & Conditions shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">12. Changes to Terms</h2>
            <p>
              We may revise these Terms & Conditions from time to time. The most current version will always be posted on this page with the "Last Updated" date. Continued use of the service after changes constitutes acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">13. Contact Information</h2>
            <p>
              If you have any questions about these Terms & Conditions, please contact us at:
            </p>
            <p className="mt-2">
              Email: <a href="mailto:support@avodah.dev" className="text-blue-600 hover:underline">support@avodah.dev</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 font-serif">14. Severability</h2>
            <p>
              If any provision of these Terms & Conditions is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that these terms shall otherwise remain in full force and effect.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t">
          <Button onClick={() => navigate("/")} className="w-full sm:w-auto">
            Return to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
